module.exports = __webpack_public_path__ + "8e0a78eb0000e2253ba63ae8bfab956b.MP3";